import {AppAction} from '../../appActions';
import {ComposerPanelActionsEnum} from './composerPanelActions';
import {ComposerPanelState} from './composerPanelState';

export function composerPanelReducer(state: ComposerPanelState, action: AppAction): ComposerPanelState {
  switch (action.type) {
    case ComposerPanelActionsEnum.FORCE_COMPOSER_POPOUT:
      return {
        ...state,
        shouldForcePopout: true,
      };

    default:
      return state;
  }
}
